export const GOOGLE_KEY='AIzaSyC4yyvAooYUCEFKSb8lgEUwezdE0oe0NhA';
// export const API_URL='http://localhost:5000'
// export const API_URL='https://do-you-bus-backend-2.diegozarate.now.sh'
export const API_URL='https://do-you-bus-backend-2-bczh893ee.now.sh'
